import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { formDraftService, type SaveFormDraftDto } from '@/services/form-draft/form-draft.service';

export const useGetFormDraft = (
  applicantProcessId?: string,
  formId?: string,
  options?: any
) =>
  useQuery<any, Error>({
    queryKey: ['form-draft', applicantProcessId, formId],
    queryFn: () => formDraftService.getDraft(applicantProcessId!, formId!),
    enabled: !!applicantProcessId && !!formId,
    ...options,
  });

/** Drafts held against an application — used to badge the queue listing. */
export const useGetApplicationDrafts = (applicantProcessId?: string, options?: any) =>
  useQuery<any, Error>({
    queryKey: ['form-drafts', 'application', applicantProcessId],
    queryFn: () => formDraftService.getByApplication(applicantProcessId!),
    enabled: !!applicantProcessId,
    ...options,
  });

export const useSaveFormDraft = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: SaveFormDraftDto) => formDraftService.save(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['form-draft', variables.applicantProcessId, variables.formId],
      });
      queryClient.invalidateQueries({
        queryKey: ['form-drafts', 'application', variables.applicantProcessId],
      });
    },
  });
};

export const useDiscardFormDraft = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ applicantProcessId, formId }: { applicantProcessId: string; formId: string }) =>
      formDraftService.discard(applicantProcessId, formId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['form-draft', variables.applicantProcessId, variables.formId],
      });
      queryClient.invalidateQueries({
        queryKey: ['form-drafts', 'application', variables.applicantProcessId],
      });
    },
  });
};
